import React, { Component, createRef, Fragment } from 'react';
import Axios from 'axios';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { Form, Field, FormSpy } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import createDecorator from 'final-form-focus';
import arrayMutators from "final-form-arrays";
import { 
    isRequiredSelectionTos,
    isRequiredStateSelection,
    isRequiredText,
    validateEmail,
    conditionallyRequiredNPINumber
} from './helpers/Validation';
import { stateList, professionalDesignationList, numberTypeList } from './helpers/Form';
import Loader from 'react-loader-spinner';

const focusOnErrors = createDecorator();

class SignUpDRPForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            submitted: false,
            validForm: false,
            npiSelected: false
        }
    }

    onSubmit = async (values) => {
        const reactState = this;
        let url = "/";
        if(process.env.NODE_ENV === "development") {
          url = "http://localhost:8000/"
        }
        values.formType = 'signUp';
        values.guid = false;
        values.indication = 'Dementia';
        try {
            await Axios({
                method: 'post',
                url: url + "api/signup",
                data: values,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            })
            .then(function (res) {
              reactState.setState({
                ...reactState.state,
                submitted: true
              });
            });
            this.scrollToForm();
        }
        catch(errors) {
            console.log("errors", errors)
        }
    }

    scrollToForm = () => {
		this.toTop.current.scrollIntoView({ behavior: "smooth" }); 
    }

    toTop = createRef();

    render() {
        const { submitted, validForm, npiSelected } = this.state;
        return (
            <div className="grid acadia-form acadia-drp-form relative sign-up" ref={this.toTop}>
                <a name="sign-up-form"></a>
                <div className="row">
                    <div className="col-lg-12 content-form">
                        <Form
                            onSubmit={this.onSubmit}
                            submitted={submitted}
                            decorators={[ focusOnErrors ]}
                            mutators={{
                                ...arrayMutators
                            }}
                        >
                            {({ handleSubmit, submitting, values }) => (
                                <form onSubmit={handleSubmit}>
                                {submitted && (
                                    <div className="offer-signup" style={{ marginTop: "2em"}}>
                                        <div className="col-lg-8 offset-lg-2">
                                            <h2>Thank you for signing up to receive more information about NUPLAZID.</h2>
                                        </div>
                                    </div>
                                )}
                                {!submitted && (  
                                    <Fragment>
                                        <div className="row">
                                            <div className="col-lg-12 text-left">
                                                <p>Welcome.</p>
                                                <p class="mt-0">As you join the communication series, you'll find a range of topics that will assess treatment challenges, share thoughts and clinical findings from key opinion leaders, and give you access to the most up-to-date resources, educational opportunities, and more.</p>
                                                <p>All fields are required unless marked &ldquo;Optional.&rdquo;</p>  
                                            </div>    
                                        </div>
                                        <div className="row">
                                            <Field className="form-control full-width-input border-0 p-0" name="special" component="input">
                                                {({ input, meta }) => (
                                                    <Fragment>
                                                        <input {...input}  type="text" style={{opacity: 0, height:"0px"}} tabIndex="-1" />
                                                    </Fragment>
                                                )}
                                            </Field>
                                            <Field className="form-control full-width-input border-0 p-0" name="special" component="input">
                                                {({ input, meta }) => (
                                                    <Fragment>
                                                        <input {...input}  type="text" style={{opacity: 0, height:"0px"}} />
                                                    </Fragment>
                                                )}
                                            </Field>
                                            <div className="col-lg-10 offset-lg-1">
                                                <div className="form-group relative">
                                                    <Field name="firstName" component="input" validate={isRequiredText}>
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label className="text-left full-width full-width-input signup-label">First Name</label>
                                                                <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="form-group relative">
                                                    <Field name="lastName" component="input" validate={isRequiredText}>
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label className="text-left full-width full-width-input signup-label">Last Name</label>
                                                                <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="form-group relative">
                                                    <Field name="emailAddress" component="input" validate={validateEmail}>
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label className="text-left full-width full-width-input signup-label">Email</label>
                                                                <input {...input} className="form-control full-width-input signup-input" type="text" placeholder="Example: john.smith@gmail.com" />
                                                                {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="form-group relative">
                                                    <Field name="address" component="input" validate={isRequiredText}>
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label className="text-left full-width full-width-input signup-label">Address</label>
                                                                <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="form-group relative">
                                                    <Field name="city" component="input" validate={isRequiredText}>
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label className="text-left full-width full-width-input signup-label">City</label>
                                                                <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field
                                                                name="state"
                                                                component="select"
                                                                validate={isRequiredStateSelection}
                                                            >                        
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className={meta.error && meta.touched ? "error" : ""} htmlFor="state">State</label>
                                                                        <select {...input} className="select-state-css select-css" type="select">
                                                                            <option name="" value="">- Select state -</option>
                                                                            {Object.entries(stateList).map(function(state) {
                                                                                return (<option key={state[0]} name="state" value={state[0]}>{state[1]}</option>);
                                                                            })}
                                                                        </select>
                                                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                       {meta.error && meta.touched && meta.error }          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field name="zipCode" component="input" validate={isRequiredText}>
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className="text-left full-width">Zip Code</label>
                                                                        <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                        {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group relative">
                                                    <Field
                                                        name="professionalDesignation"
                                                        component="select"
                                                        validate={isRequiredStateSelection}
                                                    >                        
                                                        {({ input, meta }) => (
                                                            <Fragment>
                                                                <label htmlFor="professionalDesignation">Professional Designation</label>
                                                                <select {...input} className="select-state-css" type="select">
                                                                    <option name="" value="">- Select -</option>
                                                                    {professionalDesignationList.map((professionalDesignation, index) => {
                                                                        return (<option key={professionalDesignation} name="professionalDesignation" value={professionalDesignation}>{professionalDesignation}</option>);
                                                                    })}
                                                                </select>
                                                                <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                {meta.error && meta.touched && meta.error }          
                                                            </Fragment>
                                                        )}
                                                    </Field>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field
                                                                name="numberType"
                                                                component="select"
                                                            >                        
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label htmlFor="numberType">Number Type (Optional)</label>
                                                                        <select {...input} className="select-state-css text-left full-width" type="select">
                                                                            <option name="" value="">- Select -</option>
                                                                            {numberTypeList.map((numberType, index) => {
                                                                                return (<option key={numberType} name="numberType" value={numberType}>{numberType}</option>);
                                                                            })}
                                                                        </select>
                                                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                        {meta.error && meta.touched && meta.error }          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <OnChange name="numberType">
                                                        {(value, previous) => {
                                                            this.setState({
                                                                ...this.state,
                                                                npiSelected: value === "NPI" ? true : false
                                                            });
                                                        }}
                                                    </OnChange>
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field
                                                                name="number"
                                                                component="input" 
                                                                validate={conditionallyRequiredNPINumber(npiSelected ? 1 : 0)}
                                                                key={npiSelected ? 1 : 0}
                                                            >
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className="text-left full-width">Number {npiSelected ? "" : "(Optional)"}</label>
                                                                        <input 
                                                                            {...input}
                                                                            className="form-control full-width-input signup-input"
                                                                            type="text"
                                                                            maxLength={10}
                                                                            inputMode="numeric"
                                                                        />
                                                                        {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group relative">
                                                    <label className="inline-checkboxes tos">                            
                                                        <Field
                                                            name="agreeToTerms"
                                                            component="input"
                                                            type="checkbox"
                                                            validate={isRequiredSelectionTos}
                                                        >
                                                            {({ input, meta }) => (
                                                                <Fragment>
                                                                    <input {...input} value={input.value} checked={input.checked} />
                                                                    {meta.error && meta.touched && meta.error }
                                                                </Fragment>
                                                            )}
                                                        </Field>{' '}
                                                        <span></span>
                                                        By clicking &ldquo;Submit,&rdquo; I understand and agree to the <a href="https://www.acadia-pharm.com/privacy/" target="_blank">Privacy Policy</a> and <a href="https://www.acadia-pharm.com/terms/" target="_blank">Terms of Use</a>. I agree to receive communications from Acadia&nbsp;Pharmaceuticals&nbsp;Inc.
                                                    </label>
                                                    <div className="row button-group">
                                                        <div className="col-sm-6">
                                                            <FormSpy
                                                                subscription={{ valid: true }}
                                                                onChange={props => {
                                                                    this.setState({
                                                                        ...this.state,
                                                                        validForm: props.valid
                                                                    });
                                                                }}
                                                            />
                                                            <button className={"btn align-center submit signup-submit float-right " + (submitting ? "loading" : "") + (validForm ? " valid-submit" : "")} type="submit" disabled={submitting}>
                                                                Submit <i class="fa fa-angle-right ml-2 align-middle" style={{position: "relative", top: "-3px"}}></i>
                                                                {submitting && (
                                                                    <Loader
                                                                        type="ThreeDots"
                                                                        color="#FFF"
                                                                        height={100}
                                                                        width={100}
                                                                        className="loading-icon"
                                                                    />
                                                                )}
                                                            </button>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <a className="btn align-center submit signup-submit float-left" style={{margin: "20px 10px"}} href="/" disabled={submitting}>
                                                                Cancel <i class="fa fa-angle-right ml-2 align-middle" style={{position: "relative", top: "-3px"}}></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>    
                                        {process.env.NODE_ENV === "development" && (
                                            <pre style={{marginTop: "100px", marginBottom: "50px"}}>{JSON.stringify(values, 0, 2)}</pre>
                                        )}
                                    </Fragment>
                                )}
                            </form>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
  const { selectedUser, questionOptions } = state;
  return { selectedUser: selectedUser, questionOptions: questionOptions };
}

export default connect(mapStateToProps, actions)(SignUpDRPForm);
